import { RadioCard, RadioCardProps, Stack, Text } from "@mantine/core";

import { useTranslation } from "~/hooks/use-typed-translation";

import classes from "./date-slot.module.scss";

interface DateSlot {
  date: Date;
}

export const DateSlot = ({ date, ...rest }: DateSlot & RadioCardProps) => {
  const { i18n } = useTranslation();

  return (
    <RadioCard
      className={classes["radio-card"]}
      radius="md"
      py="sm"
      value={date.toISOString()}
      {...rest}>
      <Stack gap={3}>
        <Text fz={13} ta={"center"} tt="capitalize">
          {date.toLocaleDateString(i18n.language, {
            weekday: "short",
          })}
        </Text>
        <Text fz={18} fw={600} ta={"center"} my="3">
          {date.getDate()}
        </Text>
        <Text fz={13} ta={"center"} miw="4ch" tt="capitalize">
          {date.toLocaleDateString(i18n.language, {
            month: "short",
          })}
        </Text>
      </Stack>
    </RadioCard>
  );
};
